import { FC } from "react";
import { MDSButton, MDSButtonVariant, MDSText, MDSTextVariant, MDSTextWeight } from "@/mds";
import {
  FooterContainer,
  StepContent,
  StepTitle,
  WizardContentWrapper,
} from "@/components/onboarding/components/welcome-wizard/welcome-wizard.styles";

type Props = {
  onNext: () => void;
};

export const OnboardingMeetingsPermissionsIntro: FC<Props> = ({ onNext }) => {
  return (
    <WizardContentWrapper>
      <StepTitle>Let Mem take your meeting notes</StepTitle>
      <StepContent>
        <MDSText variant={MDSTextVariant.ParagraphSm} weight={MDSTextWeight.Regular}>
          Mem can automatically detect active meetings on your device. With just one click, and Mem
          will start a meeting recording and take notes for you.
        </MDSText>
      </StepContent>
      <FooterContainer align="flex-end">
        <MDSButton variant={MDSButtonVariant.Contrast} onClick={onNext}>
          Set up
        </MDSButton>
      </FooterContainer>
    </WizardContentWrapper>
  );
};
